/**
 * Form pipeline step 4: Public form component generation
 * Routes to single-step or multi-step generator based on schema structure.
 */

import { isMultiStepForm } from '@core-engine/schema/field-helpers/index.js'
import type { FormSchema, GeneratorOptions } from '@core-engine/schema/types.js'
import { generateMultiStepForm } from '@next-adapter/generators/form-pipeline/form-component-multistep.js'
import type { StepResult } from '@next-adapter/generators/form-pipeline/form-component-shared.js'
import { generateSingleStepForm } from '@next-adapter/generators/form-pipeline/form-component-single.js'

export function generateFormComponent(
  schema: FormSchema,
  cwd: string,
  adminDir: string,
  options: GeneratorOptions
): StepResult {
  if (isMultiStepForm(schema) && schema.steps!.length > 1) {
    return generateMultiStepForm(schema, cwd, adminDir, options)
  }
  return generateSingleStepForm(schema, cwd, adminDir, options)
}
